// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Bjp-","option":"styles_option__1ywA7","active":"styles_active__3fAg7"};